import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { ritualSteps } from '../../data/ritual';
import type { Product } from '../../types/product';
export function ProductDetails({
  product
}: {
  product: Product;
}) {
  const [open, setOpen] = useState<number>(0);
  const sections = [{
    title: 'Beschrijving',
    body: product.what
  }, {
    title: 'Werking',
    body: product.does
  }, {
    title: 'Zo gebruik je het',
    body: product.use
  }];
  const step = product.ritualStep ? ritualSteps[product.ritualStep - 1] : undefined;
  return <section id="details" className="mx-auto grid max-w-7xl gap-10 px-5 py-16 lg:grid-cols-12 lg:px-8 lg:py-24" data-id="element-313" data-mp="nox5n5f39lfr">
      <div className="lg:col-span-7" data-id="element-314" data-mp="skcgrplpp38h">
        <h2 className="font-display text-3xl uppercase tracking-display sm:text-4xl" data-id="element-315" data-mp="doo4dd68p9ti">Productinformatie</h2>
        <ul className="mt-8 border-b border-line" data-id="element-316" data-mp="ioiuhei6xvdi">
          {sections.map((s, i) => {
          const isOpen = open === i;
          return <li key={s.title} className="border-t border-line" data-id="element-317" data-mp="33003jby437bx" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? -1 : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between py-5 text-left text-lg font-semibold" data-id="element-318" data-mp="2xy0xtvewfybt">
                  {s.title}
                  <PlusIcon className={`h-5 w-5 transition-transform duration-200 ${isOpen ? 'rotate-45 text-pink' : ''}`} aria-hidden="true" data-id="element-319" data-mp="2k7xh1jysgwtr" />
                </button>
                <AnimatePresence initial={false} data-id="element-320" data-mp="2szzfxdt7m51x">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-321" data-mp="2o99a5zgvg06p">
                      <p className="max-w-2xl pb-6 text-lg leading-relaxed text-muted" data-id="element-322" data-mp="3vmbf059ukevf">{s.body}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>

      {step && product.ritualStep && <aside className="self-start rounded-3xl bg-surface p-8 lg:col-span-4 lg:col-start-9" data-id="element-323" data-mp="e5jxlh0djc00">
          <p className="text-sm font-medium text-pink" data-id="element-324" data-mp="3cpa5q899fslo">Stap {product.ritualStep} van 9</p>
          <p className="mt-2 font-display text-2xl uppercase tracking-display" data-id="element-325" data-mp="3hnlfyk3gw54f">{step.title}</p>
          <p className="mt-2 text-muted" data-id="element-326" data-mp="3ml3qug11ouf2">{step.text}</p>
          <div className="mt-6 flex gap-1" aria-hidden="true" data-id="element-327" data-mp="3rkq3oocyo8nc">
            {ritualSteps.map((_, i) => <span key={i} className={`h-1 flex-1 rounded-full ${i < product.ritualStep! ? 'bg-pink' : 'bg-line'}`} data-id="element-328" data-mp="11vxsrge99qyt" data-mpi={i} />)}
          </div>
          <Link to="/over-amira" className="mt-6 inline-block text-sm font-medium underline underline-offset-4" data-id="element-329" data-mp="16t7hsuxqg0m4">
            Bekijk alle 9 stappen
          </Link>
        </aside>}
    </section>;
}